export const USER_ROLE = 'ROLE_USER';
export const ADMIN_ROLE = 'ROLE_ADMIN';

export const MENU_ITEMS = [
  // {
  //   key: 'images',
  //   title: 'Images',
  //   path: '/images',
  //   icon: 'file-image',
  //   role: [USER_ROLE, ADMIN_ROLE],
  //   permissionKey: ['imagePermission']
  // },
  {
    key: 'qualityControl',
    title: 'Quality control',
    path: '/quality_control',
    icon: 'control',
    role: [USER_ROLE, ADMIN_ROLE],
    permissionKey: ['qualityControlPermission']
  },
  {
    key: 'socialMediaQualityControl',
    title: 'Social media QC',
    path: '/social_media_quality_control',
    icon: 'control',
    role: [USER_ROLE, ADMIN_ROLE],
    permissionKey: ['socialMediaPermitted']
  },
  {
    key: 'finalReview',
    title: 'Final review',
    path: '/final_review',
    icon: 'file-search',
    role: [USER_ROLE, ADMIN_ROLE],
    permissionKey: ['reviewPermission']
  },
  {
    key: 'table',
    title: 'Search',
    path: '/search',
    icon: 'table',
    role: [USER_ROLE, ADMIN_ROLE],
    permissionKey: ['tablePermission']
  },
  {
    key: 'import',
    title: 'Import',
    path: '/import',
    icon: 'download',
    role: [USER_ROLE, ADMIN_ROLE],
    permissionKey: ['importPermission']
  },
  {
    key: 'domainManagement',
    title: 'Domain Management',
    path: '/domain-management',
    icon: 'cluster',
    role: [USER_ROLE, ADMIN_ROLE],
    permissionKey: ['domainPermission']
  },
  {
    key: 'imageManagement',
    title: 'Original Image Management',
    path: '/image-management',
    icon: 'picture',
    role: [USER_ROLE, ADMIN_ROLE],
    permissionKey: ['imageManagementPermission']
  },
  {
    key: 'targetManagement',
    title: 'Target Management',
    path: '/target-management',
    icon: 'rocket',
    role: [USER_ROLE, ADMIN_ROLE],
    permissionKey: ['importPermission']
  },
  {
    key: 'blacklistedPattern',
    title: 'Blacklisted Patterns',
    path: '/blacklisted-pattern',
    icon: 'issues-close',
    role: [USER_ROLE, ADMIN_ROLE],
    permissionKey: ['domainManagementPermission']
  },
  {
    key: 'uploadOriginals',
    title: 'Upload original images',
    path: '/upload-original',
    icon: 'upload',
    role: [USER_ROLE, ADMIN_ROLE],
    permissionKey: ['imageUploadPermission']
  },
  {
    key: 'admin',
    title: 'Admin panel',
    path: '/admin-panel',
    icon: 'setting',
    role: [ADMIN_ROLE],
    permissionKey: ['']
  }
];
